import { type DependencyList, useEffect, useRef } from 'react';

/**
 * Runs `seed` only once upstream data is available, guarding against Tambi's form values being
 * clobbered by post-turn revalidation re-firing the effect. Return `false` from `seed` to
 * retry on the next dependency change instead of marking the form seeded.
 */
export function useSeedFormOnce(
  seed: () => unknown,
  deps: DependencyList,
): void {
  const hasSeededRef = useRef(false);
  useEffect(() => {
    if (hasSeededRef.current) return;
    if (seed() === false) return;
    hasSeededRef.current = true;
    // biome-ignore lint/correctness/useExhaustiveDependencies: deps array is opaque at this layer; call sites own correctness
  }, deps);
}
